module.exports = __webpack_public_path__ + "assets/cccb56273ce26a5cd36ba6e5de56962d.png";